/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import {ReactComponent as ArrowDown} from "../assets/img/icons/arrowDown.svg";
import {ReactComponent as CheckboxEmpty} from "../assets/img/forms/checkbox-empty.svg";
import {ReactComponent as CheckboxFull} from "../assets/img/forms/checkbox-full.svg";

const FilterCheckbox = (props) => {
    const [open, setOpen] = useState(false);

    function clickHundler(){
        setOpen(!open);
    }

    function handle(e){
        if( e.target.checked === true ){
           // props.onSelect(oldArray => [...oldArray, e.target.value]);
            props.onSelect(prevState => ({
                ...prevState,
                page: 1,
                criteria: [...prevState.criteria, e.target.value],
            }));
        }else{
            let array = [...props.selected];
            let index = array.indexOf(e.target.value);
            if (index !== -1) {
                array.splice(index, 1);
                //props.onSelect(array);
                props.onSelect(prevState => ({
                    ...prevState,
                    page: 1,
                    criteria: array,
                }));
            }
        }
    }

    return (
        <>
            { Array.isArray(props.filter.criteria) &&  props.filter.criteria.length > 0 && <div className={`filter-checkbox ${open ? "opened" : ""}`}>
                <div className='filter-checkbox__header' onClick={clickHundler}>
                    <div className='filter-checkbox__icon'><img src={props.filter.image} alt={props.filter.title}/> </div>
                    <div className='filter-checkbox__label text--title'>{props.filter.title} </div>
                    <div className='filter-checkbox__arrow'><ArrowDown/></div>
                </div>
                {open && <div className='filter-checkbox__body'>
                    {
                        Object.keys(props.filter.criteria).map((key, index) => {
                            return(
                                <label className="custom-checkbox" key={index}>
                                    <input type="checkbox" onChange={ (e) =>{ handle(e) } } value={props.filter.criteria[key].criteria_id}/>
                                    <span className="custom-checkbox__icon custom-checkbox__empty"><CheckboxEmpty/></span>
                                    <span className="custom-checkbox__icon custom-checkbox__checked"><CheckboxFull/></span>
                                    {props.filter.criteria[key].title}
                                </label>
                            );
                        })
                    }

                </div>}
            </div>}
        </>
    );
};

FilterCheckbox.defaultProps = {
    filter: {},
};

export default FilterCheckbox;
